import React, { useState } from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { MemberForm, MemberFormData } from "../form/MemberForm";
import { USER_ROLE } from "../../../constants/app";
import { Toast } from "../../atoms/Toast";
import { useMemberToast, useMemberRegistration } from "../../pages/members/hook";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: MemberFormData) => void;
  onSuccess?: () => void;
  onError?: (error: string) => void;
  refetchMembers?: () => void;
};

// Helper function to map USER_ROLE to UserRole
// const mapUserRole = (userRole: USER_ROLE): UserRole => {
//   switch (userRole) {
//     case USER_ROLE.ADMIN:
//       return UserRole.ADMIN;
//     case USER_ROLE.MANAGER:
//       return UserRole.MANAGER;
//     case USER_ROLE.ASSISTANT:
//       return UserRole.ASSISTANT;
//     case USER_ROLE.NORMAL_USER:
//       return UserRole.NORMAL_USER;
//     default:
//       return UserRole.NORMAL_USER;
//   }
// };

export const CreateMemberModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  onSuccess,
  onError,
  refetchMembers
}) => {
  const [loading, setLoading] = useState(false);
  const { toast, showToast, hideToast } = useMemberToast();
  const { handleRegisterMember } = useMemberRegistration(showToast, refetchMembers);

  const handleFormSubmit = (data: MemberFormData, onErrorCb: (message: string) => void) => {
    setLoading(true);
    handleRegisterMember(
      {
        username: data.name,
        email: data.email,
        role: data.userRole as any,
      },
      (message) => {
        setLoading(false);
        onError?.(message);
        onErrorCb(message);
      },
      () => {
        setLoading(false);
        onSubmit?.(data);
        onSuccess?.();
        setTimeout(() => {
          onClose();
        }, 1200);
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Create Member"
        onClose={onClose}
      >
        <MemberForm
          key={isOpen ? 'open' : 'closed'}
          handleSubmit={handleFormSubmit}
          loading={loading}
          defaultValues={{
            name: "",
            email: "",
            userRole: USER_ROLE.NORMAL_USER,
          }}
        />
      </ModalTemplate>
    </div>
  );
};
